import { useHistory } from 'react-router'
import { NonAuthRoutes } from '../model'
import { ConfirmationDialogs } from '../model/enums/confirmationDialogs'
import { ProcedureFormModeType } from '../pages/procedures/procedures.types'
import { useConfirmationDialog } from './useConfirmationDialog'

export type ShowGoToProceduresType = {
  contractID: number
  capacityCode?: string
  origin: ProcedureFormModeType
  newDate?: Date // will set newDate input field
  type?: ConfirmationDialogs
  cancelAction?: () => void
  capacityStartDate?: string
}

type UseShowGoToProceduresType = {
  getShowGoToProceduresDialog: (showGoToProceduresType: ShowGoToProceduresType) => Promise<void>
}

export enum EnumGoToProceduresType {
  GENERIC = 1,
  TERMINATION
}

export const useShowGoToProcedures = (): UseShowGoToProceduresType => {
  const history = useHistory()
  const { getConfirmation, closeConfirmation } = useConfirmationDialog()

  const getShowGoToProceduresDialog = async ({
    contractID,
    origin,
    capacityCode,
    newDate,
    cancelAction,
    type = ConfirmationDialogs.GO_TO_PROCEDURES,
    capacityStartDate
  }: ShowGoToProceduresType) => {
    return await getConfirmation(type, undefined, true).then(
      confirm => {
        history.push(NonAuthRoutes.ProceduresAdd, {
          contractId: contractID,
          capacityCode: capacityCode,
          formMode: origin,
          newDate,
          capacityNewStartDate: capacityStartDate
        })
        closeConfirmation()
      },
      cancel => {
        cancelAction && cancelAction()
        closeConfirmation()
      }
    )
  }

  return { getShowGoToProceduresDialog }
}
